import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as StylesThemeProvider } from '@mui/styles';
import type { FC } from 'react';
import { useEffect, useMemo } from 'react';
import { Toaster } from 'react-hot-toast';
import { useLocation, useRoutes } from 'react-router';
import RTL from './components/RTL';
import SplashScreen from './components/SplashScreen';
import { gtmConfig } from './config';
import useAuth from './hooks/useAuth';
import useScrollReset from './hooks/useScrollReset';
import useSettings from './hooks/useSettings';
import gtm from './lib/gtm';
import routes from './routes';
import { isGuestAuthRoute } from './utils/guestAuthRoutes';
import { createCustomTheme } from './theme';
import SimpleSnackBar from './components/widgets/snackBar/SimpleSnackBar';
// import { useDispatch } from 'react-redux';
// import { getAllprojects } from './store/slices/projectsSlice';
// import { thunks } from './store/thunks/projects';

const App: FC = () => {
  const content = useRoutes(routes);
  const { pathname } = useLocation();
  const { settings } = useSettings();
  const auth = useAuth();
  const showAppContent = auth?.isInitialized || isGuestAuthRoute(pathname);

  useScrollReset();
  // const navigate = useNavigate();
  // let inactivityTimer;

  // Define a function to handle user inactivity and redirect
  // const handleInactivity = () => {
  //   clearTimeout(inactivityTimer);
  //   // Redirect to the login page
  //   localStorage.removeItem('accessToken');
  //   localStorage.removeItem('refreshToken');
  //   navigate('/login');
  // };

  // Reset the inactivity timer on user activity
  // const resetInactivityTimer = () => {
  //   clearTimeout(inactivityTimer);
  //   inactivityTimer = setTimeout(handleInactivity, 30 * 60 * 1000); // 30 minutes
  // };
  useEffect(() => {
    if (gtmConfig.containerId) {
      gtm.initialize(gtmConfig);
    }
    // resetInactivityTimer();

    // Add event listeners to reset the timer on user activity
    // window.addEventListener('mousemove', resetInactivityTimer);
    // window.addEventListener('keydown', resetInactivityTimer);

    // Clean up the event listeners when the component unmounts
    // return () => {
    //   window.removeEventListener('mousemove', resetInactivityTimer);
    //   window.removeEventListener('keydown', resetInactivityTimer);
    // };
  }, []);

  const theme = useMemo(
    () =>
      createCustomTheme({
        direction: settings.direction,
        responsiveFontSizes: settings.responsiveFontSizes,
        roundedCorners: settings.roundedCorners,
        theme: settings.theme,
      }),
    [
      settings.direction,
      settings.responsiveFontSizes,
      settings.roundedCorners,
      settings.theme,
      auth?.user?.organizationId,
      auth?.isAuthenticated,
    ]
  );

  return (
    <ThemeProvider theme={theme}>
      <StylesThemeProvider theme={theme}>
      <RTL direction={settings.direction}>
        <CssBaseline />
        <SimpleSnackBar />
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              textTransform: 'capitalize',
            },
          }}
        />
        {/* <SettingsDrawer /> */}
        {showAppContent ? content : <SplashScreen />}
      </RTL>
      </StylesThemeProvider>
    </ThemeProvider>
  );
};

export default App;
